export const zIndex = {
  mobileNavOverlay: 1,
  mobileNav: 2,
  header: 10,
  mobileNavButtons: 13,
  modal: 15,
  cookieBar: 28,
  pageTransitionMask: 30,
}
